import React from 'react'
import { CobuStack } from '@cobu/ui'
import { Strings } from '../../constants/Strings'

export type PublicProfileImageModalProps = {
  visible: boolean
  imageUrl?: string
  onClose: () => void
}

export default function PublicProfileImageModal({ visible, imageUrl, onClose }: PublicProfileImageModalProps) {
  if (!visible) return null
  const imageModalStrings = Strings.get().publicProfile.imageModal

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        backgroundColor: 'var(--blackTransparent75)'
      }}
      onClick={onClose}
    >
      <CobuStack pos="absolute" style={{ top: 16, right: 20, zIndex: 1 }}>
        <button
          onClick={(e) => { e.stopPropagation(); onClose() }}
          style={{ width: 40, height: 40, background: 'var(--blackTransparent50)', border: 'none', cursor: 'pointer' }}
          aria-label={imageModalStrings.closeLabel}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden>
            <path d="M18 6L6 18M6 6l12 12" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      </CobuStack>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          padding: 16,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {imageUrl ? (
          <img src={imageUrl} alt={imageModalStrings.profileAlt} style={{ maxWidth: '100%', maxHeight: '90%', objectFit: 'contain' }} />
        ) : (
          <CobuStack w="100%" h="100%" ai="center" jc="center" bg="$backgroundSecondary">
            <svg width="48" height="48" viewBox="0 0 24 24" aria-hidden>
              <path d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14" fill="none" stroke="var(--colorSecondary, #9B9B9B)" strokeWidth="2"/>
              <path d="M3 19l6-6 4 4 5-5 3 3" fill="none" stroke="var(--colorSecondary, #9B9B9B)" strokeWidth="2"/>
            </svg>
          </CobuStack>
        )}
      </div>
    </div>
  )
}


